export var createPasswordPdfScreenEvent = function createPasswordPdfScreenEvent() {
  return {
    eventType: 'screen',
    action: 'viewed',
    actionSubject: 'mediaViewerPasswordPdfScreen',
    name: 'mediaViewerPasswordPdfScreen'
  };
};